/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const CropIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
    >
      <path
        d="M17.5312 3.28171H4.46875C3.92174 3.28171 3.39714 3.49901 3.01034 3.8858C2.62355 4.27259 2.40625 4.7972 2.40625 5.34421V18.4067C2.40625 18.9537 2.62355 19.4783 3.01034 19.8651C3.39714 20.2519 3.92174 20.4692 4.46875 20.4692H17.5312C18.0783 20.4692 18.6029 20.2519 18.9897 19.8651C19.3765 19.4783 19.5938 18.9537 19.5938 18.4067V5.34421C19.5938 4.7972 19.3765 4.27259 18.9897 3.8858C18.6029 3.49901 18.0783 3.28171 17.5312 3.28171ZM18.2188 18.4067C18.2188 18.589 18.1463 18.7639 18.0174 18.8928C17.8885 19.0218 17.7136 19.0942 17.5312 19.0942H4.46875C4.28641 19.0942 4.11155 19.0218 3.98261 18.8928C3.85368 18.7639 3.78125 18.589 3.78125 18.4067V5.34421C3.78125 5.16187 3.85368 4.987 3.98261 4.85807C4.11155 4.72914 4.28641 4.65671 4.46875 4.65671H17.5312C17.7136 4.65671 17.8885 4.72914 18.0174 4.85807C18.1463 4.987 18.2188 5.16187 18.2188 5.34421V18.4067Z"
        fill="white"
      />
      <path
        d="M19.5938 0.875458H18.2188V2.93796H19.5938V0.875458Z"
        fill="white"
      />
      <path d="M22 3.28171H19.9375V4.65671H22V3.28171Z" fill="white" />
      <path
        d="M19.5938 20.4692H18.2188V22.5317H19.5938V20.4692Z"
        fill="white"
      />
      <path d="M22 19.0942H19.9375V20.4692H22V19.0942Z" fill="white" />
      <path
        d="M3.78125 0.875458H2.40625V2.93796H3.78125V0.875458Z"
        fill="white"
      />
      <path d="M2.0625 3.28171H0V4.65671H2.0625V3.28171Z" fill="white" />
      <path
        d="M3.78125 20.4692H2.40625V22.5317H3.78125V20.4692Z"
        fill="white"
      />
      <path d="M2.0625 19.0942H0V20.4692H2.0625V19.0942Z" fill="white" />
    </svg>
  )
}
